interface IProps {
    captionData: string
}

export const CaptionComponent = ({captionData}: IProps) => {
    return (
        <figcaption className="mt-2 text-base text-sm text-black italic">
              {captionData}
        </figcaption>
    );
}

export default CaptionComponent;